import { Button, Icon } from '@data-products-and-ai/react-components';
import React, { useRef } from 'react';

interface ActionBarProps {
  onClickUpload: (file: File) => void;
  onClickDelete: () => void;
  onSync: () => void;
  onClickOpenActivity: () => void;
}

const color = '#8a00e5';

const ActionBar: React.FC<ActionBarProps> = ({
  onClickUpload,
  onClickDelete,
  onSync,
  onClickOpenActivity,
}: ActionBarProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClickUpload = () => {
    inputRef.current?.click();
  };

  const handleFileChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onClickUpload(file);
    }
  };

  return (
    <div className="action-bar">
      <div className="action-bar_uploadButton">
        <Button
          onClick={handleClickUpload}
          type="primaryNoShadow"
          icon={<Icon icon="IconUpload" color="white" iconSize={0.9} />}
        >
          Upload
        </Button>
        <input
          data-testid="inputFiles"
          type="file"
          ref={inputRef}
          style={{ display: 'none' }}
          onChange={handleFileChanged}
          onClick={(event) => ((event.target as HTMLInputElement).value = "")}
        />
      </div>
      <div className="action-bar_actionButtons">
        <h5 className="action-bar_title">Files</h5>
        <Button
          onClick={onSync}
          type="headless"
          textColor={color}
          allCaps={false}
          icon={<Icon icon="IconReset" iconSize={0.9} color={color} />}
        >
          Sync
        </Button>
        <Button
          onClick={onClickDelete}
          type="headless"
          textColor={'red'}
          allCaps={false}
          disabled={true}
          icon={<Icon icon="IconTrash" iconSize={0.9} color={'red'} />}
        >
          Delete
        </Button>
      </div>
      <div className="action-bar_activityButton">
        <Button
          onClick={onClickOpenActivity}
          type="headless"
          textColor={color}
          allCaps={false}
          icon={<Icon icon="IconUnorderedList" iconSize={1} color={color} />}
        >
          Activity
        </Button>
      </div>
    </div>
  );
};

export default ActionBar;
